import { DRAWER_MENU_OPTIONS } from "../types";

export interface IDrawerMenu {
  menu:any;
}

const initialState: IDrawerMenu = {
  menu: [],
};

export const drawerMenuOptionsReducer = (state: IDrawerMenu = initialState, action: any): IDrawerMenu => {
 
    switch (action.type) {
      case DRAWER_MENU_OPTIONS.DRAWER_MENU_OPTIONS_SET_SELECTED:
        return {
          ...state,
          menu: action.payload.menu,
        };
  
      case DRAWER_MENU_OPTIONS.DRAWER_MENU_OPTIONS_CLEAR_SELECTED:
        return {
          ...state,
          menu: [],
        };
  
      default:
        return state;
    }
  };
